import { useQuery } from "@tanstack/react-query";
import { StaticTranslationsTableData } from "modules/translations/pages/StaticTranslations/types";
import { queryClient } from "shared/api/queryClient";
import { getStaticTranslations } from "../api/getStaticTranslations";

const QUERY_KEY = "static-translations";
export const useStaticTranslationsQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      const response = await getStaticTranslations();

      const normalizedTranslationsData =
        response?.map((item) => {
          const { translations, path, ...rest } = item;

          return {
            ...rest,
            ...translations,
            contentItem: item.contentItem.length
              ? item.contentItem
              : item.translations.en,
          } as StaticTranslationsTableData;
        }) ?? [];

      return normalizedTranslationsData;
    },
  });
};

export const invalidateStaticTranslations = () => {
  return queryClient.invalidateQueries({
    queryKey: [QUERY_KEY],
  });
};
